module.exports = __webpack_public_path__ + "img/LT302574840.fd58aebf.svg";